export type PageSample = {
  src: string
  level: string
  title: string
  caption: string
}

export const pageSamples: PageSample[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/odq3TNrmKZ8yWBuq85tkei/Captura-de-pantalla-2026-09-13-a-las-2.24.47_p._m..webp',
    level: 'Volume 1 · Preschool Activity',
    title: 'Practice With the Three Levels',
    caption:
      'Ready-to-print worksheet: nine real movement photos to identify as high, middle or low, plus a draw-yourself exercise for ages 3–5.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/te2pKYdZyxXeG4toCT6TRf/Captura-de-pantalla-2026-09-13-a-las-2.27.48_p._m..webp',
    level: 'Volume 2 · Technique Guide',
    title: 'The Perfect Plié — Basic Knee Bend',
    caption:
      'The four positions of the plié broken down step by step, with alignment cues and a clear DO / DON\u2019T comparison for correcting mistakes.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/usGpCoVLfCXFTwbNqMUxjt/Captura-de-pantalla-2026-09-13-a-las-2.28.59_p._m..webp',
    level: 'Volume 3 · Movement Infographic',
    title: 'Grand Allegro — Big Jumps & Leaps',
    caption:
      'Petit vs. grand allegro side by side, with jeté, grand jeté and assemblé illustrated and explained for when to use each one.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ui69LSP41EMYi95eYiTnZH/Captura_de_pantalla_2026-09-13_a_las_2.31.24_p.webp',
    level: 'Volume 5 · Choreography Framework',
    title: 'Competitive Choreography',
    caption:
      'A five-phase structure with exact timings — opening, build, peak, resolution, finale — plus the judging criteria weighting.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wrqKyBKtQqv9RititTVncC/Captura_de_pantalla_2026-09-13_a_las_2.33.16_p.webp',
    level: 'Volume 6 · Elite Unit',
    title: 'Competitive Psychology & Elite Mindset',
    caption:
      'Performance psychology, resilience and the mental training protocols used by champions, written for advanced and professional levels.',
  },
]
